export const typeOptions = [
	{ id: 0, value: 'supervision-card', label: 'Cédula de supervisión' },
	{ id: 1, value: 'supervision-bulletin', label: 'Boletín de supervisión' },
	{ id: 2, value: 'documento-hallazgos', label: 'Reporte de hallazgos' },
	{ id: 3, value: 'documento-evidencias', label: 'Reporte de actividades' },
];
